import { destroyCookie, setCookie } from 'nookies'
import { BroadcastChannel } from 'broadcast-channel'

const logoutChannel = new BroadcastChannel('logout')

interface Cookies {
  userId: string
  accessToken: string
  refreshToken: string
}

const handleDestroyCookies = () => {
  destroyCookie(undefined, 'userId')
  destroyCookie(undefined, 'accessToken')
  destroyCookie(undefined, 'refreshToken')
  destroyCookie(undefined, 'profileImageURL')
  destroyCookie(undefined, 'email')
}

export const handleSetCookies = ({
  userId,
  accessToken,
  refreshToken,
}: Cookies) => {
  handleDestroyCookies()

  setCookie(undefined, 'userId', userId, {
    maxAge: 60 * 600,
  })
  setCookie(undefined, 'accessToken', accessToken, {
    maxAge: 60 * 300,
  })
  setCookie(undefined, 'refreshToken', refreshToken, {
    maxAge: 60 * 300,
  })
}

const handleLogout = () => {
  handleDestroyCookies()

  if (!window.location.href.includes('/login')) {
    window.location.href = '/login'
  }
}

export const handleLogoutAllTabs = () => {
  handleLogout()

  logoutChannel.postMessage('logout')

  logoutChannel.onmessage = () => {
    handleLogout()
  }
}
